/**
 * Small shared utility functions used across the client app.
 */

/**
 * Numeric comparator for sorting arrays of numeric-like values.
 *
 * Coerces both values to `Number` so it can be used for arrays containing
 * numbers or numeric strings.
 */
export const numericSort = <T extends number | string>(a: T, b: T) =>
  Number(a) - Number(b);
